export function getProp(prop, state) {
  return prop != null ? prop : state;
}
export function noop() {}